import React from "react";
import ISOHeader27001 from "../../../components/ISO Certificates/ISO 27001-2013/ISOHeader27001";
import ISOContent27001 from "../../../components/ISO Certificates/ISO 27001-2013/ISOContent27001";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";
import ISOSpecifications27001 from "../../../components/ISO Certificates/ISO 27001-2013/ISOSpecifications27001";

const ISO270012013 = () => {
  return (
    <div>
      <ISOHeader27001 />
      <ISOContent27001 />
      <ISOServiceIndia9001 />
      <ISOSpecifications27001 />
    </div>
  );
};

export default ISO270012013;
